import React from "react";

function CommentEditIcon({...props}) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            viewBox='0 0 48 48'
            fill='none'
            {...props}
        >
            <rect x='4' y='4' width='40' height='40' rx='20' fill='#F2F4F7' />
            <rect
                x='4'
                y='4'
                width='40'
                height='40'
                rx='20'
                stroke='#F9FAFB'
                stroke-width='8'
            />
            <path
                d='M17.3191 30.2742H17.4232L20.1939 30.0189C20.5816 29.9811 20.9409 29.8109 21.2151 29.5366L31.6738 19.078C32.1655 18.5863 32.4397 17.9338 32.4397 17.2435C32.4397 16.5532 32.1655 15.9007 31.6738 15.409L31.0024 14.7376C30.0189 13.7541 28.3073 13.7541 27.3239 14.7376L25.9905 16.0709L16.8747 25.1868C16.6005 25.461 16.4303 25.8203 16.4019 26.208L16.1466 28.9787C16.1182 29.3286 16.2411 29.669 16.487 29.9244C16.7139 30.1513 17.0071 30.2742 17.3191 30.2742ZM29.1678 15.3901C29.4704 15.3901 29.773 15.5035 30 15.74L30.6714 16.4113C30.7819 16.52 30.8696 16.6495 30.9295 16.7923C30.9894 16.9352 31.0203 17.0886 31.0203 17.2435C31.0203 17.3984 30.9894 17.5518 30.9295 17.6947C30.8696 17.8375 30.7819 17.967 30.6714 18.0756L29.8392 18.9078L27.5035 16.5721L28.3357 15.74C28.5626 15.513 28.8652 15.3901 29.1678 15.3901ZM17.8109 26.3404C17.8109 26.2837 17.8392 26.2364 17.8771 26.1986L26.4917 17.5745L28.8274 19.9102L20.2128 28.5248C20.2128 28.5248 20.1182 28.591 20.0709 28.591L17.5839 28.818L17.8109 26.331V26.3404ZM34.331 33.2908C34.331 33.6785 34.0095 34 33.6217 34H14.7092C14.3215 34 14 33.6785 14 33.2908C14 32.9031 14.3215 32.5816 14.7092 32.5816H33.6217C34.0095 32.5816 34.331 32.9031 34.331 33.2908Z'
                fill='#475467'
            />
        </svg>
    );
}

export default CommentEditIcon;
